import React,{useEffect, useState} from 'react'
import {Box,Stack,Button,Typography,TextField} from '@mui/material'
import { fetchData,exercisesOptions } from '../utils/fetchData'
import HorizontalScrollBar from './HorizontalScrollBar'
  
 const SearchExercises = ({bodyPart,setBodyPart,setExercises}) => {
  
  const [search ,setSearch]=useState('');
  
  const [bodyParts,setBodyParts]=useState([]);

  useEffect(()=>{
    const fetchExercisesData = async() => {
      const bodyPartsData =await fetchData('https://exercisedb.p.rapidapi.com/exercises/bodyPartList',exercisesOptions);
      setBodyParts(['all',...bodyPartsData]);
    }
     
    fetchExercisesData();
  },[])


  const handleSearch = async () => {
     if(search){
         const response = await fetchData('https://exercisedb.p.rapidapi.com/exercises',exercisesOptions);
         
         
         const searchedExercises = response.filter((element)=>{ return (element.name.toLowerCase()===search || element.target.toLowerCase()===search || element.bodyPart.toLowerCase()===search || element.equipment.toLowerCase()===search );});
         
         setSearch('');
         setExercises(searchedExercises);
         
     }
     

  }
 
  return (
    <Stack alignItems="center"  mt= "37px">
      <Typography fontWeight={700} p="20" sx={{fontSize:{lg :'44px',xs:'30px'}}} mb="50px" textAlign="center" >
          Awersome Exercises You <br/> Should know 
      </Typography> 
     
     <Box position='relative' mb='72px'>
      <TextField 
      sx={{input:{
        fontWeight: '700',
        border: 'none',
        borderRadius:'4px'
      },
      width:{lg: '800px' , xs:'350px'},
      backgroundColor:'#fff',
      borderRadius:'40px'
    }}
      height="76px" value={search} onChange={(e) => setSearch(e.target.value.toLowerCase())}
      placeholder="Search Exercises"
      type="text"
      />
      <Button className="search-btn" sx={{backgroundColor: '#ff2625' , textTransform:'none', color:"#fff", width: {lg: '175px',xs:'80px'},fontSize:{lg: '20px',xs: '14px'} , height:'56px',position:'absolute',right:'0px'}}
         onClick={handleSearch}
      >
           Search
      </Button>
      </Box>
      <Box sc={{position:'absolute',width:'100%',p:'20px'}}>
          <HorizontalScrollBar position="absolute" data={bodyParts} bodyPart={bodyPart} setBodyPart={setBodyPart}/>
      </Box>
    </Stack>
  )
}


export default SearchExercises;
